// eslint-disable-next-line no-unused-vars
export const getTotal = (fabrics = [], positions = [], processes = []) => {
  return +(
    // (fabrics || []).reduce((acc, item) => acc + (+item.total || 0), 0) +
    (
      (positions || []).reduce((acc, item) => acc + (+item.total || 0), 0) +
      (processes || []).reduce((acc, item) => acc + (+item.total || 0), 0)
    ).toFixed(2)
  );
};

export const getProductTotalA = (styles = []) => {
  return +(styles || [])
    .reduce((acc, item) => acc + (+item.totalA || 0), 0)
    .toFixed(2);
};

export const getProductTotalB = (styles = []) => {
  return +(styles || [])
    .reduce((acc, item) => acc + (+item.totalB || 0), 0)
    .toFixed(2);
};

export const getProductTotalC = (styles = []) => {
  return +(styles || [])
    .reduce((acc, item) => acc + (+item.totalC || 0), 0)
    .toFixed(2);
};
